import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Row, Col, InputGroup, InputGroupText, Input } from 'reactstrap';
import queryString from 'query-string';
import { FlashMessageContext } from 'contexts/FlashMessageContext';
import { AuthContext } from 'contexts/AuthContext';
import { SpinnerButton } from 'common/SpinnerButton';
import { checkRegistrationToken, finishRegistration } from 'utils/api/authAPI';
import Logo from 'images/logo.png';

export const ConfirmInvite = () => {
    let navigate = useNavigate();
    const { addFlashMessage } = useContext(FlashMessageContext);
    const { signIn, logout } = useContext(AuthContext);

    const [token, setToken] = useState(null);
    const [tokenChecked, setTokenChecked] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    let queryParams = useLocation();

    const redirectToInvalidLink = () => {
        navigate('/invite-expired');
    };

    const checkToken = async () => {
        try {
            const parsedQuery = queryString.parse(queryParams.search);
            await checkRegistrationToken(parsedQuery.token);

            setToken(parsedQuery.token);
            setTokenChecked(true);
        } catch (err) {
            redirectToInvalidLink();
        }
    };

    useEffect(() => {
        logout();
        checkToken();
    }, []);

    const onSubmit = async () => {
        try {
            setSubmitting(true);
            const params = {
                token,
                plainPassword: {
                    first: password,
                    second: confirmPassword,
                },
            };
            const res = await finishRegistration(params);

            if (res?.area === 'reader') {
                navigate('/company/reader/signin');
                return;
            }

            signIn(res.token);
            navigate('/account/users');
            setSubmitting(false);
        } catch (err) {
            if (err.errors.timezone) {
                addFlashMessage('danger', 'You must select a valid timezone.');
            }
            setSubmitting(false);
        }
    };

    if (!tokenChecked) {
        return null;
    }
    return (
        <div className="auth-block">
            <div className="auth-block__form">
                <div className="animated fadeIn">
                    <Row className="justify-content-center mt-5" style={{ marginBottom: '.5rem' }}>
                        <Col md={9}>
                            <div className="auth-block__image-container">
                                <a href="/">
                                    <img src={Logo} alt="Ozmosys" className="auth-block__image img-fluid" />
                                </a>
                            </div>
                            <div>
                                <div className="text-center mb-4">
                                    <h2>Complete Registration</h2>
                                    <p className="mt-4 mb-3 text-muted">
                                        Please set up your password
                                        <br />
                                        (Minimum 6 Characters)
                                    </p>
                                </div>

                                <InputGroup>
                                    <InputGroupText>
                                        <i className="fa fa-lock" />
                                    </InputGroupText>
                                    <Input
                                        placeholder="Password (Min 6 Characters)"
                                        type="password"
                                        name="password"
                                        onChange={(e) => setPassword(e.target.value)}
                                        value={password}
                                    />
                                </InputGroup>

                                <InputGroup>
                                    <InputGroupText>
                                        <i className="fa fa-lock" />
                                    </InputGroupText>
                                    <Input
                                        placeholder="Confirm Password"
                                        type="password"
                                        name="confirmPassword"
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                        value={confirmPassword}
                                    />
                                </InputGroup>

                                <Row>
                                    <Col xs="12" className="text-right">
                                        <SpinnerButton
                                            type="submit"
                                            color="primary"
                                            className="px-4"
                                            block
                                            onClick={onSubmit}
                                            submitting={submitting}
                                            title="Sign In"
                                        />
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    );
};
